import React from 'react'
import ReactDOM from 'react-dom'
import { BannerContext } from 'core/providers/BannerProvider'

const BannerContent = ({ children }: { children: React.ReactNode | JSX.Element }) => {
  const { bannerContainer } = React.useContext(BannerContext)
  if (!bannerContainer) {
    return null
  }
  return ReactDOM.createPortal(children, bannerContainer)
}

export default BannerContent
